unable to read source [project]/packages/react/src/insertionFactory.ts